import React from 'react';
import { Column, ListTable } from '@/components/pages/dashboard/tiles/bottomTile/bottomTileTables/ListTable';
import { Faculty } from '@/wpt-lib/interfaces/Faculty';
import { Switch } from '@chakra-ui/react';

interface Props {
    faculties: (Faculty & { changed?: boolean })[];
    onUpdate: (faculty: Faculty) => void;
}

const FacultyEditorTable = ({ faculties, onUpdate }: Props) => {
    const Columns: Column<Faculty & { changed?: boolean }>[] = [
        {
            name: 'Code',
            getData: (f) => f.name,
            highlight: (f) => !!f.changed,
        },
        {
            name: 'Active',
            getData: (f) => (
                <Switch
                    isChecked={!f.inactive}
                    onChange={() => onUpdate({ ...f, inactive: !f.inactive })}
                    size="md"
                    colorScheme="blue"
                />
            ),
            width: '5%',
        },
    ];

    return <ListTable tableCaption="Faculties" columns={Columns} getActions={() => []} data={faculties} />;
};

export default FacultyEditorTable;
